import React, { memo } from 'react';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { TitleStyled, ContainerStyled } from './HeroSectionStyled';
export const HeroSection = memo(({ image, title }) => {
    return (React.createElement(ContainerStyled, { imageUrl: image?.src, srcSet: image?.srcSet },
        React.createElement(TitleStyled, { color: colorCoreWhite1000 }, title)));
});
HeroSection.displayName = 'HeroSection';
